import { useState } from 'react'
import styles from './styles.module.scss'
import Container from '../../../elements/Container'
import DateSearch from '../../../elements/DateSearch'
import classNames from 'classnames'
import Section from '../../../elements/Section'
import Button from '../../../elements/Button'
import { getS3Url } from '../../../helpers/getS3Url'
import Link from 'next/link'
import { useRouter } from 'next/router'

const Welcome = ({ shadowRef, pageData, translations, headerTranslation }) => {
  const [isActive, setIsActive] = useState(false)
  const router = useRouter()

  const propertyTitle = pageData.propertyTitle
  const propertyBedrooms = pageData.propertyBedrooms
  const propertyType = pageData.propertyType

  return (
    <Section
      variant={['center', 'z-7']}
      className={styles.welcome}
      bg={
        pageData.cloudflare_image_section
          ? getS3Url(pageData.cloudflare_image_section, '1980')
          : getS3Url(pageData.image_section)
      }
      cloudflare={
        pageData.cloudflare_video_section
          ? getS3Url(pageData.cloudflare_video_section, '', true)
          : false
      }
    >
      <Container className={styles.welcome__container}>
        <div className={styles.welcome__shadow}></div>
        <div className={styles.welcome__content}>
          <h1
            dangerouslySetInnerHTML={{
              __html: translations.page.welcome.title[router.locale]
            }}
            className={styles.welcome__title}
          ></h1>

          {/* {isLoaded && ( */}
          <div className={styles.welcome__wrapper}>
            <div
              className={classNames(
                styles.welcome__card,
                isActive && styles.isActive
              )}
            >
              <DateSearch
                setIsActive={setIsActive}
                isActive={isActive}
                shadowRef={shadowRef}
                translations={headerTranslation}
                optional
                form={['dates', 'bedrooms', 'listings']}
              />
            </div>
          </div>
          {/* )} */}

          <div>
            <Button
              href="/real-estate/search"
              variant={['secondary']}
              arrow={true}
            >
              {headerTranslation.buyOrSell[router.locale]}
            </Button>
          </div>
        </div>
      </Container>

      {propertyTitle && propertyBedrooms && propertyType && (
        <div className={styles.welcome__promo}>
          <Link
            href={`/vacation-rentals/${propertyTitle
              .toLowerCase()
              .replace(/ /g, '-')}-${propertyBedrooms}-bedroom-${propertyType}`}
          >
            <a>
              {translations.page.welcome.featured[router.locale]}{' '}
              {propertyTitle}
            </a>
          </Link>
        </div>
      )}
    </Section>
  )
}

export default Welcome
